import React from "react";
import "./PhoneInput.scss";
import MuiPhoneNumber from "material-ui-phone-number";
interface PhoneInputProps {
  label: string;
  value: string;
  onChange: any;
  required?: boolean;
  error?: string;
}
const PhoneInput: React.FC<PhoneInputProps> = ({
  label,
  value,
  onChange,
  required,
  error,
}) => {
  return (
    <div className='wr-input'>
      <div className='wr-input-lable'>
        {label}
        {required && <span className='req-ic'>*</span>}
      </div>
      <div className='wr-input-wrapper'>
        <div className='wr-input-cont'>
          <MuiPhoneNumber
            defaultCountry={"gb"}
            onChange={onChange}
            value={value}
            style={{ width: "110%" }}
          />
        </div>
      </div>
      {error !== "" && <div className='wr-input-error'>{error}</div>}
    </div>
  );
};
export default PhoneInput;
